export const BUTTON_WIDTH = 48; // Width of each button in pixels
export const CONTAINER_PADDING = 20; // Padding around the button group in pixels
export const MAX_VISIBLE_BUTTONS = 4; // Maximum number of buttons to show
export const MAX_VISIBLE_BUTTONS_NEW_LAYOUT = 2; // Maximum number of buttons to show in new layout
export const HEADER_RESPONSIVE_BREAKPOINT = 718; // Breakpoint for header responsive behavior

export const BRANDING_LABEL_ID = 'owaBranding_container';
export const TENANT_LOGO_ID = 'tenantLogo_container';
export const OVERFLOW_MENU_BUTTON_ID = 'owaOverflowMenuBtn_container';
export const APP_LAUNCHER_BUTTON_ID = 'owaAppLauncherBtn_container';

// Default activation height is 20% of typical viewport height
export const SHY_HEADER_DEFAULT_ACTIVATION_HEIGHT = 240;
